import { useTranslation } from 'react-i18next'
import { Modal } from '../../../../components'
import { useAppDispatch } from '../../../../redux/hook'
import { deleteBrand } from '../../slice/brandSlice'
interface AddModalProps {
    show: boolean
    onClose: (value: boolean) => void
    data: {
        name: string
        description: string
        id: string
    }
}

const DeleteBrand = ({ show, onClose, data }: AddModalProps) => {
    const { t } = useTranslation()
    const dispatch = useAppDispatch()
    return (
        <Modal
            show={show}
            handleClose={() => onClose(false)}
            title={t('brand.brandModals.deleteModalTitle')}
            body={<p>Are you sure want to delete {data.name} brand?</p>}
            defaultFooter={true}
            onSuccess={() => {
                dispatch(deleteBrand(data.id))
                onClose(false)
            }}
        />
    )
}
export default DeleteBrand
